module.exports = __webpack_public_path__ + "img/round2.473b5f17.png";